module.exports = __webpack_public_path__ + "static/img/blogo.4b2a564.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/blogo.png
// module id = rG6Q
// module chunks = 49